@if (!hasMoreRecord) {
<div class="load-more-container">
    <por-base-button [featureName]="featureName" [class]="'theme-button'" (onclick)="onLoadMore()">{{ 'Load' | translate }} {{ selectedValue }} {{ 'More' | translate }}</por-base-button>
    <por-base-select [selectStyle]="'load-more-select-style'" [options]="dropdownOptions" [model]="selectedValue" (modelChange)="onValueChange($event)"></por-base-select>
</div>
}
